export default {
  redeem: 'Redeem',
  unavailableRewards: 'Unavailable rewards',
  availableRewards: 'Available rewards',
  appliedReward: 'Applied reward',
  onlyOneAllowed: 'Only one reward can be applied at a time',
  noRewards: 'There are no rewards to display',
  addToSale: ' Add to sale',
  removeFromSale: 'Remove from sale',
  done: 'Done',
  continue: 'Continue',
  offerCard: {
    redeem: 'Redeem',
    remove: 'Remove',
  },
}
